import type { AdminSectionProps } from './types'
import { UsersSection } from './UsersSection'
import { AdminCard } from './AdminCard'
import { useAuthToken } from './useAuthToken'

/** Раздел «Сотрудники»: RBAC-управление кассирами и правами. */
export function StaffSection({ cashier }: AdminSectionProps) {
  const token = useAuthToken()
  if (cashier?.role !== 'admin') {
    return (
      <div className="rounded-panel border border-line bg-white p-4 text-small text-muted">
        Управление сотрудниками доступно только администратору.
      </div>
    )
  }
  return (
    <AdminCard
      id="staff.users"
      title="Управление кассирами и правами доступа"
      defaultOpen
    >
      <UsersSection token={token} />
    </AdminCard>
  )
}
